// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-22ff7671]{height:calc(100% - 260px)}.nodlist[data-v-22ff7671],.titHead[data-v-22ff7671]{display:flex}.titHead[data-v-22ff7671]{align-items:center;margin-top:30px;margin-bottom:6px;font-size:16px}.titHead .titItem[data-v-22ff7671]{margin-right:50px;margin-left:20px;font-weight:700}", ""]);
// Exports
module.exports = exports;
